import { useState } from "react";
import styles from "./styles";
import Calendar from "./Calendar/Calendar";
import arrowImg from "../../../../picture/PlayLanguage.png";


function CustomCalendarInput({ label, value, onChange }) {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const handleOpenCalendar = () => {
    setIsCalendarOpen(true);
  };
  const handleCloseCalendar = () => {
    setIsCalendarOpen(false);
  };

  return (
    <div style={{ position: "relative",}}>
      <div style={styles.natpis}>{label}</div>
      <div
        onClick={handleOpenCalendar}
        style={{ position: "relative", width: "6vw", display: "flex", alignItems: "center" }}
      >
        <input
          value={value}
          readOnly
          style={{
            fontSize: "16px",
            height: "40px",
            padding: "10px",
            width: "6vw",
          }}
        />
        <img src={arrowImg} alt="" style={{ height: "13px", position: "absolute", right: "10px", transform: "rotate(90deg)" }} />
      </div>
      {isCalendarOpen && (
        <Calendar
          isOpen={isCalendarOpen}
          handleClose={handleCloseCalendar}
          selectedDate={value}
          handleClickDate={onChange}
        />
      )}

      
    </div>
  );
}

export default CustomCalendarInput;
